module.exports = __webpack_public_path__ + "img/7800.ddcf7373.jpg";